<template>
    <div class="PermissionAssignment" style="
    box-shadow: rgb(107 105 105 / 21%) 0px 0px 20px 0px;
    ">
        <p class="comeback" @click="comeback()">
            <span class="el-icon-arrow-left"></span>
            <span>返回</span>
        </p>
        <h4 v-if="look">查看权限</h4>
        <h4 v-else>权限分配</h4>
        <div class="rolemeaasge">
            <p>
                <span class="color999">角色中文名</span><span class="color333">{{allroute.cnName}}</span>
            </p>
            <p>
                <span class="color999">角色英文名</span><span class="color333">{{allroute.enName}}</span>
            </p>
        </div>
        <div class="PermissionBox">
            <p class="tit color333">对应权限</p>
            <el-checkbox v-model="checkall" :disabled="allisDisabled" class="color999 checkall" @change="handleCheckAllChange">选择所有权限</el-checkbox>
            <el-collapse v-model="activeNames" @change="handleChange">
                <el-collapse-item :title="item.name" :name="item.resourceId" v-for="(item,index) in PermissionData" :key="index">
                    <template slot="title">
                        <el-checkbox v-model="item.isAllocation" :disabled="isDisabled" @change="CheckAllChange(item.isAllocation,item)">{{item.name}}</el-checkbox>
                    </template>
                    <div class="color999 checkbox" v-for="(item_1,index_1) in item.nextNodes" :key="index_1">
                        <p class="titcheck">
                            <el-checkbox v-model="item_1.isAllocation" text-color="#fff" :disabled="isDisabled" @change="CheckAllChange(item_1.isAllocation,item_1)" style="margin-left:20px;">
                                {{item_1.name}}
                            </el-checkbox>
                        </p>
                        <p class="titcheck">
                            <el-checkbox v-model="item_2.isAllocation" :disabled="isDisabled" v-for="(item_2,index_2) in item_1.nextNodes" :key="index_2">{{item_2.name}}</el-checkbox>
                        </p>
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div>
        <div v-if="allroute.type == '权限分配'" class="btn_list">
            <!-- <el-button @click="cancelBtn()">取消</el-button> -->
            <el-button  @click="affirmBtn()" style="margin-left:30px;">确认</el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name:"PermissionAssignment",
        data() {
            return {
                look:true,//控制权限切换
                allisDisabled:false,//全选复选框禁止勾选
                isDisabled:false,//其他复选框禁止勾选
                allroute:{},//路由接受当前角色所有属性
                cnName:"",//角色中文名
                enName:"",//角色英文名
                checkall:false,//全选
                activeNames: ['1'],//默认显示的折叠面板
                PermissionData:[],//所有查询权限数据
                shendata:[],//深拷贝所有数据
                resourceIdList:[],//确认选中集合
            }
        },
        methods: {
            comeback(){//返回上一页
                this.$router.push({name: 'ManagementRole', query: {}});
            },
            checkcheck(){//检测全选
                // this.shendata
                let newarr=[],allarr=[];
                const getStr_allcheck = function(list){
                    list.forEach(function(row){
                        if(row.nextNodes){
                            getStr_allcheck(row.nextNodes);
                            allarr.push(row);
                            if(row.isAllocation){
                                newarr.push(row.resourceId);

                            }
                        }else {
                            allarr.push(row);
                            if(row.isAllocation){
                                newarr.push(row.resourceId);
                            }
                        }
                    })
                }
                getStr_allcheck(this.shendata);
                if(allarr.length == newarr.length){
                    this.checkall = true;
                }else{
                    this.checkall = false;
                }
            },
            handleCheckAllChange(val){//全选
                const getStr = function(list){
                    list.forEach(function(row){
                        if(row.nextNodes !== null){
                            if(val){
                                row.isAllocation = true;
                            }else {
                                row.isAllocation = false;
                            }
                            getStr(row.nextNodes)
                        }else {
                            if(val){
                                row.isAllocation = true;
                            }else {
                                row.isAllocation = false;
                            }
                        }
                    })
                }
                getStr(this.PermissionData);
            },
            CheckAllChange(val,item){//第二层级全选控制/
                // console.log(val,item)
                const geterstr_1 = function(list){
                    if(list !== null){
                        list.forEach(function(row){
                            if(row.nextNodes !== null){
                                if(val){
                                    row.isAllocation = true;
                                }else {
                                    row.isAllocation = false;
                                }
                                geterstr_1(row.nextNodes)
                            }else {
                                if(val){
                                    row.isAllocation = true;
                                }else {
                                    row.isAllocation = false;
                                }
                            }
                        })
                    }
                }
                geterstr_1(item.nextNodes);
            },
            cancelBtn(){//取消
                this.PermissionData = JSON.parse(JSON.stringify(this.shendata));
            },
            affirmBtn(){//确认
                let newarr=[];
                const getStrend = function(list){
                    list.forEach(function(row){
                        if(row.nextNodes){
                            getStrend(row.nextNodes);
                            if(row.isAllocation){
                                newarr.push(row.resourceId);
                            }
                        }else {
                            if(row.isAllocation){
                                newarr.push(row.resourceId);
                            }
                        }
                    })
                };
                getStrend(this.PermissionData);
                this.resourceIdList = newarr;
                this.getConfirmCheck();
            },
            handleChange(val) {
                // console.log(val);
            },
            getallPermission(){
                let params = {
                    "roleId": this.allroute.roleid,
                };
                let that = this;
                that.axios.get(
                    "/authorization/getResourceByRoleId",
                    {params}
                )
                .then((response)=> {
                    // console.log(response);//.data.datas
                    that.PermissionData = response.data.datas;
                    that.shendata = JSON.parse(JSON.stringify(response.data.datas));
                    // console.log(that.shendata);
                    that.checkcheck();
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
            getConfirmCheck(){
                let data= {
                    "resourceIds": this.resourceIdList,
	                "roleId":this.allroute.roleid,
                };
                // console.log(data)
                let that = this;
                that.axios.post(
                    "/authorization/assignRoleResource",
                    data
                )
                .then((response)=> {
                    // console.log(response);
                    if(response.data.code!= 200){
                    this.$message.info(response.data.message)

                    return
                }
                    if(response.data.message == "成功"){
                        this.$message({
                            message: "操作成功",
                            type: 'success',
                            duration:'700',
                            onClose:()=>{
                            　　this.comeback();
                            }
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            }
        },
        mounted () {
            this.allroute = this.$route.query;
            // console.log(this.allroute);
            this.allisDisabled = false;
            this.isDisabled = false;
            if(this.allroute.type == "查看权限"){
                this.getallPermission();
                this.look = true;
                this.allisDisabled = true;
                this.isDisabled = true;
            }else if(this.allroute.type == "权限分配"){
                this.getallPermission();
                this.look = false;
                this.allisDisabled = false;
                this.isDisabled = false;
            }
        },
    }
</script>

<style>
.PermissionAssignment{
    position: relative;
    width: 100%;
    /* height: 90vh; */
    background: #FFFFFF;
    box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
    border-radius: 10px;
    box-sizing: border-box;
    overflow: hidden;
}
.PermissionAssignment .comeback{
    width: 120px;
    margin-top: 15px;
    margin-bottom: 5px;
    font-size: 18px;
    cursor:pointer;
}
.PermissionAssignment .comeback:hover{
    color: #409EFF;
}
.PermissionAssignment .comeback span:nth-child(1){
    margin-left: 8px;
    margin-right: 0px;
    font-size: 22px;
    vertical-align: -1px;
}
.PermissionAssignment h4{
    height: 30px;
    margin-top: 18px;
    margin-left: 37px;
    font-size: 24px;
    font-family: 'PingFang SC';
    color: #333333;
}
.PermissionAssignment .rolemeaasge{
    width: 40%;
    height: 26px;
    display: flex;
    margin-top: 47px;
    margin-left: 37px;
    font-size: 16px;
    line-height: 26px;
}
.PermissionAssignment .rolemeaasge p{
    width: 50%;
    font-size: 16px;
}
.PermissionAssignment .rolemeaasge p span:nth-child(2){
    margin-left: 22px;
}
.PermissionAssignment .color333{
    color: #333333;
}
.PermissionAssignment .color999{
    color: #999999;
}
/* 折叠面板 */
.PermissionAssignment .PermissionBox{
    width: 95%;
    max-height: 580px;
    margin-left: 37px;
    margin-top: 38px;
    margin-bottom: 27px;
    box-sizing: border-box;
}
.PermissionAssignment .PermissionBox .tit{
    width: 100%;
    height: 20px;
    font-size: 18px;
    line-height: 20px;
    font-family: 'PingFang SC';
}
.PermissionAssignment .PermissionBox .checkall{
    margin: 20px 0 0 20px;
    font-size: 16px;
}
/* 按钮列 */
.btn_list{
    /* position: absolute; */
    /* bottom: 20px; */
    width: 95%;
    height: 60px;
    margin-left: 2%;
    line-height: 60px;
    text-align: right;
}
.btn_list .el-button{
    width: 177px;
    height: 40px;
    background: #FFFFFF;
    border: 1px solid #FF4D01;
    color: #FF4D01;
    border-radius: 5px;
}
.btn_list .el-button:hover{
    background: #FF4D01;
    color: #fff;
    border-radius: 5px;
}
/* element */
.PermissionAssignment .PermissionBox .el-collapse{
    border-top: none;
}
.PermissionAssignment .PermissionBox .el-collapse-item__header{
    margin-top: 20px;
    padding-left: 20px;
    background: #f5f5f5;
    border: 1px solid #E6E6E6;
    /* border-bottom: none; */
    border-radius: 5px 5px 0px 0px;
}
.PermissionAssignment .el-collapse-item__wrap{
    border: 1px solid #e6e6e6;
    border-top: none;
}
.PermissionAssignment .el-collapse-item__content .checkbox{
    margin-top: 8px;
    display: flex;
}
.PermissionAssignment .el-collapse-item__content .checkbox .titcheck{
    /* height: 60px; */
    line-height: 30px;
}
.PermissionAssignment .el-collapse-item__content .checkbox .titcheck:nth-child(1){
    width: 10%;
}
.PermissionAssignment .el-collapse-item__content .checkbox .titcheck:nth-child(2){
    width: 90%;
}
.PermissionAssignment .el-collapse-item__content .checkbox .el-checkbox{
    height: 30px;
    line-height: 30px;
    margin-right: 38px;
    font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/accountManage/PermissionAssignment.vue